import { findUser } from '@/api/users-api'
import { userKeys } from '@/hooks/users/query-keys'
import { createFileRoute } from '@tanstack/react-router'

export type TabOptions = 'profile' | 'password' | 'notifications'

export type MyProfileSearch = {
  tab: TabOptions
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/users/my-profile'
)({
  validateSearch: (search: Record<string, string>): MyProfileSearch => {
    const { tab } = search

    const validatedTab = ['profile', 'password', 'notifications'].includes(
      tab as TabOptions
    )
      ? (tab as TabOptions)
      : 'profile'

    return {
      tab: validatedTab,
    }
  },
  loader: async ({ context: { queryClient, userId } }) =>
    queryClient.ensureQueryData({
      queryKey: userKeys.detail(userId ?? ''),
      queryFn: () => findUser(userId ?? ''),
    }),
})
